import { Divider, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { AdsClick, Assessment, ContentCopy, ContentCopyTwoTone, FilterList, Receipt } from '@mui/icons-material';
import { labelForField } from './tracking-page.format';
import { COPYABLE_URL, DUPLICABLE, hasEntity, RowContext } from './useRowActions';

interface Props {
  contextMenu: RowContext | null;
  onClose: () => void;
  onReport: () => void;
  onCopyUrl: () => void;
  onLeadBreakdown: () => void;
  onViewLog: (path: '/clicks' | '/conversions') => void;
  onDuplicate: () => void;
}

export default function RowContextMenu({
  contextMenu, onClose, onReport, onCopyUrl, onLeadBreakdown, onViewLog, onDuplicate,
}: Props) {
  const actionable = contextMenu && hasEntity(contextMenu);
  const copyable = actionable ? COPYABLE_URL[contextMenu.field] : undefined;
  const duplicable = actionable ? DUPLICABLE.has(contextMenu.field) : false;

  return (
    <Menu
      open={contextMenu !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
    >
      <MenuItem disabled sx={{ opacity: '1 !important', fontWeight: 600, fontSize: '0.8rem' }}>
        {contextMenu ? `${labelForField(contextMenu.field)}: ${contextMenu.label}` : ''}
      </MenuItem>
      <Divider />
      <MenuItem onClick={onReport} disabled={contextMenu?.field === 'date'}>
        <ListItemIcon><FilterList sx={{ fontSize: 18 }} /></ListItemIcon>
        Report
      </MenuItem>
      {copyable && (
        <MenuItem onClick={onCopyUrl}>
          <ListItemIcon><ContentCopy sx={{ fontSize: 18 }} /></ListItemIcon>
          Copy {copyable.label}
        </MenuItem>
      )}
      {duplicable && (
        <MenuItem onClick={onDuplicate}>
          <ListItemIcon><ContentCopyTwoTone sx={{ fontSize: 18 }} /></ListItemIcon>
          Duplicate
        </MenuItem>
      )}
      <MenuItem onClick={onLeadBreakdown}>
        <ListItemIcon><Assessment sx={{ fontSize: 18 }} /></ListItemIcon>
        Lead breakdown
      </MenuItem>
      <Divider />
      <MenuItem onClick={() => onViewLog('/clicks')}>
        <ListItemIcon><AdsClick sx={{ fontSize: 18 }} /></ListItemIcon>
        View clicks
      </MenuItem>
      <MenuItem onClick={() => onViewLog('/conversions')}>
        <ListItemIcon><Receipt sx={{ fontSize: 18 }} /></ListItemIcon>
        View conversions
      </MenuItem>
    </Menu>
  );
}
